import axios from 'axios'

const dynamicYieldBaseUrl = 'https://direct-collect.dy-api.eu/v2/collect/user'

const dynamicYieldApiKey =
  '79fab4b83eed93a23b6571af027b65f1edf0375644cb041f831511b664fba3df'

const dynamicYieldClient = axios.create({
  baseURL: dynamicYieldBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    'dy-api-key': dynamicYieldApiKey,
  },
})

export default dynamicYieldClient
